/**
 * DelayedTasksSection utilities
 * @module pages/DashboardPage/components/DelayedTasksSection
 */

/** Maximum number of delayed tasks displayed in the section */
export const DELAYED_TASKS_LIMIT = 5;
